import CustomSelectMenu, { CustomSelectMenuProps } from "@components/FormFields/CustomSelectMenu";
import { PermissionGate } from "@components/shared/PermissionGate";
import { useAddLocation } from "@hooks/useAddLocation";
import { useAuth } from "@hooks/useAuth";
import { PlusIcon } from "lucide-react";
import type { Location } from "types";

export function LocationSelectMenu(props: CustomSelectMenuProps<Location> & { onAddLocation?: (locationId: string) => void }) {
    const { user } = useAuth();
    const { openLocationAddDialog } = useAddLocation({ onSuccess: props.onAddLocation })
    if (!user?.id) return null;
    return <CustomSelectMenu
        label="Location *"
        footer={
            <PermissionGate has="locations:create" >
                <button
                    onClick={() => openLocationAddDialog()}
                    className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground"
                >
                    <PlusIcon className="h-4 w-4" />
                    Add Location
                </button>
            </PermissionGate >
        }
        {...props}
    />
}